export const getTransformedMarkers = (items) => items.map((marker) => {
    const { Street, ZipCode, PhoneNumber, City } = marker.item;
    const address = [Street, City, ZipCode, PhoneNumber].filter(Boolean).join(", ");
    return {
        ...marker.item,
        address,
    };
});
//# sourceMappingURL=getTransformedMarkers.js.map